import { FileDownloadService } from "@topline/services/fileDownloadService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ToasterService } from "@topline/services/toasterService";

(function (module) {
    "use strict";
    module.component("dtpTable", {
        template: require("./dtp-table.html"),
        bindings: {
            forecast: "=",
            parameters: "<",
            historicalData: "<",
            isEditable: "<",
            isRf: "<"
        },
        controller: [
            "$scope",
            angularServicesNames.$translate,
            "dtpChartService",
            "synchronousEventsBus",
            ToasterService.componentName,
            FileDownloadService.componentName,
            "selectElementAndConvertService",
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                dtpChartService: $TSFixMe,
                synchronousEventsBus: $TSFixMe,
                toasterService: ToasterService,
                fileDownloadService: FileDownloadService,
                selectElementAndConvertService: $TSFixMe
            ) {
                const $ctrl = this;

                $ctrl.coordinatesSelectedCells = null;
                $ctrl.showSpecialElement = false;

                $scope.sumHistoricalData = function (arr: $TSFixMe, name: $TSFixMe) {
                    let sum = 0;
                    arr.map(function (item: $TSFixMe) {
                        sum += item[name];
                    });
                    return sum;
                };

                $scope.showInput = function (idx: $TSFixMe) {
                    $scope.showElement = idx;
                };

                $scope.sumCorrectData = function (arr: $TSFixMe) {
                    let sum = 0;
                    arr.map(function (item: $TSFixMe) {
                        if (item.correctData !== undefined && item.correctData !== null && item.correctData !== "") {
                            sum += parseFloat(item.correctData);
                        } else {
                            if (item.historical !== null) {
                                sum += parseFloat(item.historical);
                            }
                        }
                    });
                    return sum;
                };

                $scope.$watch("$ctrl.historicalData", function (newValues: $TSFixMe, oldValues: $TSFixMe) {
                    if (angular.isUndefinedOrNull($ctrl.historicalData)) return;

                    let data = null;
                    let labels = dtpChartService.preparePeriodsAndLabels(
                            $ctrl.parameters.historicalDataStart,
                            $ctrl.parameters.historicalDataEnd
                        ),
                        summaryYearData = dtpChartService.countMonthWithData(labels.periods);
                    $scope.labels = labels.periods;

                    if ($ctrl.forecast.dataAfterCorrection) {
                        let copyCorrectData = $ctrl.forecast.dataAfterCorrection.slice();
                        data = dtpChartService.prepareDataToTable(
                            summaryYearData,
                            $ctrl.historicalData.slice(),
                            copyCorrectData
                        );
                    } else {
                        data = dtpChartService.prepareDataToTable(summaryYearData, $ctrl.historicalData.slice());
                    }

                    const dataToChart = dtpChartService.prepareData(data);
                    $ctrl.dataToTable = data;
                    $scope.dataToChart = dataToChart;
                });

                function startWatchCoordinatesSelectedCells() {
                    $scope.$watch(
                        "$ctrl.coordinatesSelectedCells",
                        function (nValue: $TSFixMe, oValue: $TSFixMe) {
                            if (!_.isEmpty(nValue)) {
                                const data = selectElementAndConvertService.pickElementFromArray(
                                    $ctrl.coordinatesSelectedCells,
                                    $ctrl.dataToTable,
                                    "data"
                                );
                                $ctrl.dataToResume = selectElementAndConvertService.setArithmeticAverage(data, [
                                    "historical",
                                    "correctData"
                                ]);
                                $ctrl.showSpecialElement = true;
                            } else {
                                $ctrl.showSpecialElement = false;
                            }
                        },
                        true
                    );
                }

                $ctrl.exportTable = () => {
                    toasterService.showReportGenerateBusyIndicator(
                        () =>
                            fileDownloadService.exportTable("table.xlsx", {
                                columns: [
                                    $translate.instant("DTP_TABLE.MONTH.JANUARY"),
                                    $translate.instant("DTP_TABLE.MONTH.FEBRUARY"),
                                    $translate.instant("DTP_TABLE.MONTH.MARCH"),
                                    $translate.instant("DTP_TABLE.MONTH.APRIL"),
                                    $translate.instant("DTP_TABLE.MONTH.MAY"),
                                    $translate.instant("DTP_TABLE.MONTH.JUNE"),
                                    $translate.instant("DTP_TABLE.MONTH.JULY"),
                                    $translate.instant("DTP_TABLE.MONTH.AUGUST"),
                                    $translate.instant("DTP_TABLE.MONTH.SEPTEMBER"),
                                    $translate.instant("DTP_TABLE.MONTH.OCTOBER"),
                                    $translate.instant("DTP_TABLE.MONTH.NOVEMBER"),
                                    $translate.instant("DTP_TABLE.MONTH.DECEMBER")
                                ],
                                rows: generateRowsForExport()
                            }),
                        "EXCEL_EXPORT_GENERATING",
                        "EXCEL_EXPORT_GENERATED"
                    );
                };

                $scope.updateData = function (data: $TSFixMe, item: $TSFixMe, arr: $TSFixMe) {
                    item.correctData = parseFloat(data);
                    if (isNaN(item.correctData)) {
                        item.correctData = "";
                    }
                    $scope.sumCorrectData(arr);
                    $scope.dataToChart = dtpChartService.prepareData($ctrl.dataToTable);
                    $ctrl.forecast.dataAfterCorrection = $scope.dataToChart[1];

                    synchronousEventsBus.$broadcast("dataAfterCorrectionChanged", {
                        forecast: $ctrl.forecast,
                        parameters: $ctrl.parameters
                    });
                };

                function generateRowsForExport() {
                    var rows = [];
                    for (const yearData of $ctrl.dataToTable) {
                        rows.push({
                            header: `${yearData.year} ${$translate.instant("DTP_TABLE.DATA.HISTORICAL")}`,
                            values: yearData.data.map((x: $TSFixMe) => x.historical)
                        });
                        rows.push({
                            header: `${yearData.year} ${$translate.instant("DTP_TABLE.DATA.AFTER_CORRECT")}`,
                            values: yearData.data.map((x: $TSFixMe) => x.correctData)
                        });
                    }
                    return rows;
                }

                $ctrl.$onInit = () => {
                    if ($ctrl.isRf) {
                        $ctrl.coordinatesSelectedCells = {};
                        startWatchCoordinatesSelectedCells();
                    }
                };
            }
        ]
    });
})(angular.module("topline.modules"));
